module.exports = __webpack_public_path__ + "static/img/Bachelor_010575.dadbe76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010575.jpg
// module id = 191
// module chunks = 0